import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { Form, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { SettlementsService } from 'src/app/services/settlements.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: 'app-modal-add-building',
  template: `
    <ng-template #modalBuilding let-modal>
      <div class="modal-header">
        <h5 class="modal-title" id="modalBuilding">{{ mode === 'creation' ? '' : 'Editar ' }}Edificio</h5>
        <button type="button" (click)="dismiss()" data-dismiss="modal" aria-label="Close" class="btn btn-link text-dark">
          <fa-icon [icon]="icons.faTimes"></fa-icon>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="buildingForm" (ngSubmit)="createBuilding()">
          <div class="form-group required mb-4 mt-3">
            <label for="name" class="form-label ms-2">Nombre del edificio</label>
            <input type="text" class="form-control form-control-lg rounded-3" id="name" placeholder="" formControlName="name">
            <div *ngIf="abfc['name'].touched && abfc['name'].invalid">
              <div *ngIf="abfc['name'].errors?.['required']" class="text-danger text-sm">El nombre del edificio es requerido.</div>
            </div>
          </div>
          <div class="form-group required mb-4 mt-3">
            <label for="clave" class="form-label ms-2">Clave del edificio</label>
            <input type="text" class="form-control form-control-lg rounded-3" id="clave" placeholder="" formControlName="clave">
            <div *ngIf="abfc['clave'].touched && abfc['clave'].invalid">
              <div *ngIf="abfc['clave'].errors?.['required']" class="text-danger text-sm">La clave del edificio es requerida.</div>
            </div>
          </div>
          <div class="form-group text-end mt-1 clearfix">
            <button type="submit" class="btn btn-outline-success">
              <fa-icon [icon]="icons.faSave" class="me-2" *ngIf="!loading"></fa-icon>
              <fa-icon [icon]="icons.faCircleNotch" animation="spin" class="me-2" *ngIf="loading"></fa-icon>
              {{ mode === 'creation' ? 'Agregar' : 'Guardar'}}
            </button>
          </div>
        </form>
      </div>
    </ng-template>
  `,
  styleUrls: []
})
export class ModalAddBuildingComponent implements AfterViewInit {
  @Input() settlement: any;
  @Input() building: any;
  @Output() onBuildingCreated = new EventEmitter<any>();
  @Output() updateDismiss: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('modalBuilding') modalBuilding !: TemplateRef<any>;
  mode = 'creation';
  
  private modalRef: NgbModalRef | undefined;

  loading: boolean = false;
  buildingForm: FormGroup = new FormGroup({});

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private store: SettlementsService,
    private toastr: ToastrService,
    public icons: IconsService
  ) { }

  ngAfterViewInit(): void {
    console.log('building => ', this.building);
    this.buildBuildingForm();
  }

  buildBuildingForm() {
    this.buildingForm = this.fb.group({
      id: [],
      name: ['', Validators.required],
      clave: ['', Validators.required],
      settlement_id: [],
    });
  }

  get abfc () {
    return this.buildingForm.controls;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['building'] && changes['building'].currentValue) {
      this.buildingForm.patchValue(changes['building'].currentValue);
    }
  }

  createBuilding() {
    if (this.buildingForm.invalid) {
      this.buildingForm.markAllAsTouched();
      return;
    }

    this.buildingForm.patchValue({
      settlement_id: this.settlement.id
    });

    if (!this.buildingForm.value.id) {
      this.store.createBuilding(this.buildingForm.value).subscribe({
        next: (data: any) => {
          this.toastr.success('Edificio se creó correctamente.', 'Éxito');
          this.loading = false;
          this.dismiss();
        },
        error: (err: any) => {
          this.toastr.error('Edificio no pudo ser creado.', 'Error');
        }
      });
    } else {
      this.store.updateBuilding(this.buildingForm.value.id, this.buildingForm.value).subscribe({
        next: (data: any) =>  {
          this.toastr.success('Edificio se actualizó correctamente.', 'Éxito');
          this.loading = false;
          this.dismiss();
        },
        error: (error: any) => {
          console.log('error => ', error);
          this.toastr.error('Edificio no pudo ser actualizado.', 'Error');
          this.loading = false;
        }
      });
    }

    this.onBuildingCreated.emit(this.buildingForm.value);
  }

  openModal(modalContent: TemplateRef<any>, mode = 'creation') {
    this.mode = mode;
    this.modalRef = this.modalService.open(modalContent);
  }

  dismiss() {
    if (this.modalRef) {
      this.updateDismiss.emit();
      this.modalRef.dismiss();
    }
  }
}
